import { APIClient, setAuthorization } from "./api_helper";
import { api as url } from "../config";
const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// profile
export const updateImageProfile = (data) => api.patchImg("/profiles", data);

export const postLogin = (data) => api.post(`/auth`, data);
export const logout = (data) => api.post(`/logout`, data);
export const postJwtForgetPwd = (data) => api.post("/jwt-forget-pwd", data);
export const postJwtProfile = (data) => api.post("/jwt-forget-pwd", data);
export const refreshToken = () => api.get("/refresh");

export const getReportApi = (report, path) => api.get("/reports", report, path);

export const getMailApi = (data) => api.get("/mails", data);
export const approveMailApi = (data) => api.put("/mails", data);
export const addNewMailApi = (data) => api.postImg("/mails", data);
export const updateMailApi = (data) => api.patchImg("/mails", data);
export const deleteMailApi = (data) => api.delete("/mails", data);

export const getNotificationApi = (data) => api.get("/notifications", data);
export const approveNotificationApi = (data) => api.put("/notifications", data);
export const setReadNotificationApi = (data) => api.put("/notifications", data);
export const addNewNotificationApi = (data) => api.post("/notifications", data);
export const updateNotificationApi = (data) => api.patch("/notifications", data);
export const deleteNotificationApi = (data) => api.delete("/notifications", data);

export const getClientApi = (data) => api.get(`/clients`, data);
export const addNewClientApi = (data) => api.post(`/clients`, data);
export const updateClientApi = (data) => api.patch(`/clients`, data);
export const deleteClientApi = (data) => api.delete(`/clients`, data);

export const getCompanyApi = (data) => api.get(`/companies`, data);
export const addNewCompanyApi = (data) => api.post(`/companies`, data);
export const updateCompanyApi = (data) => api.patch(`/companies`, data);
export const deleteCompanyApi = (data) => api.delete(`/companies`, data);

export const getBrandApi = (data) => api.get("/brands", data);
export const addNewBrandApi = (data) => api.post("/brands", data);
export const updateBrandApi = (data) => api.patch("/brands", data);
export const deleteBrandApi = (data) => api.delete("/brands", data);

export const getBrandExternApi = (data) => api.get("/brand-externs", data);
export const addNewBrandExternApi = (data) => api.postImg("/brand-externs", data);
export const updateBrandExternApi = (data) => api.patchImg("/brand-externs", data);
export const deleteBrandExternApi = (data) => api.delete("/brand-externs", data);

export const getBranchApi = (data) => api.get("/branches", data);
export const getOneBranchApi = (id) => api.getOne("/branches", id);
export const addNewBranchApi = (data) => api.post("/branches", data);
export const updateBranchApi = (data) => api.patch("/branches", data);
export const deleteBranchApi = (data) => api.delete("/branches", data);

export const getPrintTemplateApi = (data) => api.get("/task-print-templates", data);
export const addNewPrintTemplateApi = (data) => api.post("/task-print-templates", data);
export const updatePrintTemplateApi = (data) => api.patch("/task-print-templates", data);
export const deletePrintTemplateApi = (data) => api.delete("/task-print-templates", data);

export const getProvinceApi = (data) => api.get("/provinces", data);
export const addNewProvinceApi = (data) => api.post("/provinces", data);
export const updateProvinceApi = (data) => api.patch("/provinces", data);
export const deleteProvinceApi = (data) => api.delete("/provinces", data);

export const getCityApi = (data) => api.get("/cities", data);
export const addNewCityApi = (data) => api.post("/cities", data);
export const updateCityApi = (data) => api.patch("/cities", data);
export const deleteCityApi = (data) => api.delete("/cities", data);

export const getDistrictApi = (data) => api.get("/districts", data);
export const addNewDistrictApi = (data) => api.post("/districts", data);
export const updateDistrictApi = (data) => api.patch("/districts", data);
export const deleteDistrictApi = (data) => api.delete("/districts", data);

export const getVillageApi = (data) => api.get("/villages", data);
export const addNewVillageApi = (data) => api.post("/villages", data);
export const updateVillageApi = (data) => api.patch("/villages", data);
export const deleteVillageApi = (data) => api.delete("/villages", data);

export const getAddressApi = (data) => api.get("/addresses", data);
export const addNewAddressApi = (data) => api.post("/addresses", data);
export const updateAddressApi = (data) => api.patch("/addresses", data);
export const deleteAddressApi = (data) => api.delete("/addresses", data);

export const getIdentityApi = (data) => api.get("/identities", data);
export const addNewIdentityApi = (data) => api.post("/identities", data);
export const updateIdentityApi = (data) => api.patch("/identities", data);
export const deleteIdentityApi = (data) => api.delete("/identities", data);

export const getIdentityTypeApi = (data) => api.get("/identity-types", data);
export const addNewIdentityTypeApi = (data) => api.post("/identity-types", data);
export const updateIdentityTypeApi = (data) => api.patch("/identity-types", data);
export const deleteIdentityTypeApi = (data) => api.delete("/identity-types", data);

export const getMaritalApi = (data) => api.get("/marital-status", data);
export const addNewMaritalApi = (data) => api.post("/marital-status", data);
export const updateMaritalApi = (data) => api.patch("/marital-status", data);
export const deleteMaritalApi = (data) => api.delete("/marital-status", data);

export const getMaritalTaxApi = (data) => api.get("/marital-taxes", data);
export const addNewMaritalTaxApi = (data) => api.post("/marital-taxes", data);
export const updateMaritalTaxApi = (data) => api.patch("/marital-taxes", data);
export const deleteMaritalTaxApi = (data) => api.delete("/marital-taxes", data);
export const approveMaritalTaxApi = (data) => api.put("/marital-taxes", data);

export const getDisposalApi = (data) => api.get("/disposal", data);
export const addNewDisposalApi = (data) => api.post("/disposal", data);
export const updateDisposalApi = (data) => api.patch("/disposal", data);
export const deleteDisposalApi = (data) => api.delete("/disposal", data);
export const approveDisposalApi = (data) => api.put("/disposal", data);

export const getDepreciationApi = (data) => api.get("/depreciations", data);
export const addNewDepreciationApi = (data) => api.post("/depreciations", data);
export const updateDepreciationApi = (data) => api.patch("/depreciations", data);
export const deleteDepreciationApi = (data) => api.delete("/depreciations", data);
export const approveDepreciationApi = (data) => api.put("/depreciations", data);

export const getReligionApi = (data) => api.get("/religions", data);
export const addNewReligionApi = (data) => api.post("/religions", data);
export const updateReligionApi = (data) => api.patch("/religions", data);
export const deleteReligionApi = (data) => api.delete("/religions", data);

export const getBankApi = (data) => api.get("/banks", data);
export const addNewBankApi = (data) => api.post("/banks", data);
export const updateBankApi = (data) => api.patch("/banks", data);
export const deleteBankApi = (data) => api.delete("/banks", data);

export const getBankBranchApi = (data) => api.get("/bank-branches", data);
export const addNewBankBranchApi = (data) => api.post("/bank-branches", data);
export const updateBankBranchApi = (data) => api.patch("/bank-branches", data);
export const deleteBankBranchApi = (data) => api.delete("/bank-branches", data);

export const getBankDataApi = (data) => api.get("/bankdatas", data);
export const addNewBankDataApi = (data) => api.post("/bankdatas", data);
export const updateBankDataApi = (data) => api.patch("/bankdatas", data);
export const deleteBankDataApi = (data) => api.delete("/bankdatas", data);

export const getFolderApi = (data) => api.get("/storage-folders", data);
export const addNewFolderApi = (data) => api.post("/storage-folders", data);
export const updateFolderApi = (data) => api.patch("/storage-folders", data);
export const deleteFolderApi = (data) => api.delete("/storage-folders", data);

export const getFileApi = (data) => api.get("/storage-files", data);
export const addNewFileApi = (data) => api.postImg("/storage-files", data);
export const updateFileApi = (data) => api.patchImg("/storage-files", data);
export const deleteFileApi = (data) => api.delete("/storage-files", data);

export const getEducationApi = (data) => api.get("/educations", data);
export const addNewEducationApi = (data) => api.post("/educations", data);
export const updateEducationApi = (data) => api.patch("/educations", data);
export const deleteEducationApi = (data) => api.delete("/educations", data);

export const getEducationLevelApi = (data) => api.get("/education-levels", data);
export const addNewEducationLevelApi = (data) => api.post("/education-levels", data);
export const updateEducationLevelApi = (data) => api.patch("/education-levels", data);
export const deleteEducationLevelApi = (data) => api.delete("/education-levels", data);

export const getFamilyContactApi = (data) => api.get("/family-contacts", data);
export const addNewFamilyContactApi = (data) => api.post("/family-contacts", data);
export const updateFamilyContactApi = (data) => api.patch("/family-contacts", data);
export const deleteFamilyContactApi = (data) => api.delete("/family-contacts", data);

export const getFamilyContactTypeApi = (data) => api.get("/family-contact-types", data);
export const addNewFamilyContactTypeApi = (data) => api.post("/family-contact-types", data);
export const updateFamilyContactTypeApi = (data) => api.patch("/family-contact-types", data);
export const deleteFamilyContactTypeApi = (data) => api.delete("/family-contact-types", data);

export const getEvents = () => api.get("/permissions");
export const getCategories = () => api.get("/permission-categories");
export const getUpCommingEvent = () => api.get("/events");
export const addNewEvent = (event) => api.post("/permissions", event);
export const approveEvent = (data) => api.put("/permissions", data);
export const updateEvent = (event) => api.patch("/permissions", event);
export const deleteEvent = (event) => api.delete("/permissions", event);

//Human Resources
export const getOneEmployeeApi = (id) => api.getOne("/employees", id);
export const getEmployeeApi = (data) => api.get("/employees", data);
export const addNewEmployeeApi = (data) => api.post("/employees", data);
export const approveEmployeeApi = (data) => api.put("/employees", data);
export const updateEmployeeApi = (data) => api.patch("/employees", data);
export const deleteEmployeeApi = (data) => api.delete("/employees", data);

export const getEmployeeFaceApi = (data) => api.get("/employee-faces", data);
export const addNewEmployeeFaceApi = (data) => api.postImg("/employee-faces", data);
export const approveEmployeeFaceApi = (data) => api.put("/employee-faces", data);
export const updateEmployeeFaceApi = (data) => api.patchImg("/employee-faces", data);
export const deleteEmployeeFaceApi = (data) => api.delete("/employee-faces", data);

export const getDepartmentApi = (data, patch) => api.get("/departments", data, patch);
export const addNewDepartmentApi = (data) => api.post("/departments", data);
export const updateDepartmentApi = (data) => api.patch("/departments", data);
export const deleteDepartmentApi = (data) => api.delete("/departments", data);

export const getSectionApi = (data) => api.get("/sections", data);
export const addNewSectionApi = (data) => api.post("/sections", data);
export const updateSectionApi = (data) => api.patch("/sections", data);
export const deleteSectionApi = (data) => api.delete("/sections", data);

export const getPositionApi = (data, path) => api.get("/positions", data, path);
export const addNewPositionApi = (data) => api.post("/positions", data);
export const updatePositionApi = (data) => api.patch("/positions", data);
export const deletePositionApi = (data) => api.delete("/positions", data);

export const getPermissionCategoryApi = (data) => api.get("/permission-categories", data);
export const addNewPermissionCategoryApi = (data) => api.post("/permission-categories", data);
export const updatePermissionCategoryApi = (data) => api.patch("/permission-categories", data);
export const deletePermissionCategoryApi = (data) => api.delete("/permission-categories", data);

export const getEmployeeContractApi = (data) => api.get("/employee-contracts", data);
export const approveEmployeeContractApi = (data) => api.put("/employee-contracts", data);
export const addNewEmployeeContractApi = (data) => api.post("/employee-contracts", data);
export const updateEmployeeContractApi = (data) => api.patch("/employee-contracts", data);
export const deleteEmployeeContractApi = (data) => api.delete("/employee-contracts", data);

export const getEmployeeContractTypeApi = (data) => api.get("/employee-contract-types", data);
export const addNewEmployeeContractTypeApi = (data) => api.post("/employee-contract-types", data);
export const updateEmployeeContractTypeApi = (data) => api.patch("/employee-contract-types", data);
export const deleteEmployeeContractTypeApi = (data) => api.delete("/employee-contract-types", data);

export const getEmployeeLocationApi = (data) => api.get("/employee-locations", data);
export const approveEmployeeLocationApi = (data) => api.put("/employee-locations", data);
export const addNewEmployeeLocationApi = (data) => api.post("/employee-locations", data);
export const updateEmployeeLocationApi = (data) => api.patch("/employee-locations", data);
export const deleteEmployeeLocationApi = (data) => api.delete("/employee-locations", data);

export const getEmployeeWarningApi = (data) => api.get("/employee-warnings", data);
export const approveEmployeeWarningApi = (data) => api.put("/employee-warnings", data);
export const addNewEmployeeWarningApi = (data) => api.post("/employee-warnings", data);
export const updateEmployeeWarningApi = (data) => api.patch("/employee-warnings", data);
export const deleteEmployeeWarningApi = (data) => api.delete("/employee-warnings", data);

export const getPositionChangeApi = (data) => api.get("/position-changes", data);
export const approvePositionChangeApi = (data) => api.put("/position-changes", data);
export const addNewPositionChangeApi = (data) => api.post("/position-changes", data);
export const updatePositionChangeApi = (data) => api.patch("/position-changes", data);
export const deletePositionChangeApi = (data) => api.delete("/position-changes", data);

export const getTerminationApi = (data) => api.get("/terminations", data);
export const approveTerminationApi = (data) => api.put("/terminations", data);
export const addNewTerminationApi = (data) => api.post("/terminations", data);
export const updateTerminationApi = (data) => api.patch("/terminations", data);
export const deleteTerminationApi = (data) => api.delete("/terminations", data);

export const getPayrateApi = (data) => api.get("/pay-rates", data);
export const approvePayrateApi = (data) => api.put("/pay-rates", data);
export const addNewPayrateApi = (data) => api.post("/pay-rates", data);
export const updatePayrateApi = (data) => api.patch("/pay-rates", data);
export const deletePayrateApi = (data) => api.delete("/pay-rates", data);

export const getPayrollApi = (data) => api.get("/payrolls", data);
export const addNewPayrollApi = (data) => api.post("/payrolls", data);
export const updatePayrollApi = (data) => api.patch("/payrolls", data);
export const deletePayrollApi = (data) => api.delete("/payrolls", data);

export const getPayrollSalaryApi = (data) => api.get("/payrolls", data);
export const addNewPayrollSalaryApi = (data) => api.post("/payrolls", data);
export const approvePayrollSalaryApi = (data) => api.put("/payrolls", data);
export const updatePayrollSalaryApi = (data) => api.patch("/payrolls", data);
export const deletePayrollSalaryApi = (data) => api.delete("/payrolls", data);

export const getAttendanceApi = (data) => api.get("/attendances", data);
export const approveAttendanceApi = (data) => api.put("/attendances", data);
export const addNewAttendanceApi = (data) => api.post("/attendances", data);
export const updateAttendanceApi = (data) => api.patch("/attendances", data);
export const deleteAttendanceApi = (data) => api.delete("/attendances", data);

export const getAttEventApi = (data) => api.get("/attendance-events", data);
export const approveAttEventApi = (data) => api.put("/attendance-events", data);
export const addNewAttEventApi = (data) => api.post("/attendance-events", data);
export const updateAttEventApi = (data) => api.patch("/attendance-events", data);
export const deleteAttEventApi = (data) => api.delete("/attendance-events", data);

export const getAttScheduleApi = (data) => api.get("/attendance-schedules", data);
export const approveAttScheduleApi = (data) => api.put("/attendance-schedules", data);
export const addNewAttScheduleApi = (data) => api.post("/attendance-schedules", data);
export const updateAttScheduleApi = (data) => api.patch("/attendance-schedules", data);
export const deleteAttScheduleApi = (data) => api.delete("/attendance-schedules", data);

export const getAttScheduleDetailApi = (data) => api.get("/attendance-schedule-details", data);
export const approveAttScheduleDetailApi = (data) => api.put("/attendance-schedule-details", data);
export const addNewAttScheduleDetailApi = (data) => api.post("/attendance-schedule-details", data);
export const updateAttScheduleDetailApi = (data) => api.patch("/attendance-schedule-details", data);
export const deleteAttScheduleDetailApi = (data) => api.delete("/attendance-schedule-details", data);

export const getAccSettingApi = (data) => api.get("/acc-settings", data);
export const approveAccSettingApi = (data) => api.put("/acc-settings", data);
export const addNewAccSettingApi = (data) => api.post("/acc-settings", data);
export const updateAccSettingApi = (data) => api.patch("/acc-settings", data);
export const deleteAccSettingApi = (data) => api.delete("/acc-settings", data);

export const getPayrollComponentApi = (data) => api.get("/payroll-components", data);
export const approvePayrollComponentApi = (data) => api.put("/payroll-components", data);
export const addNewPayrollComponentApi = (data) => api.post("/payroll-components", data);
export const updatePayrollComponentApi = (data) => api.patch("/payroll-components", data);
export const deletePayrollComponentApi = (data) => api.delete("/payroll-components", data);

export const getPayrollComponentDetailApi = (data) => api.get("/payroll-component-details", data);
export const approvePayrollComponentDetailApi = (data) => api.put("/payroll-component-details", data);
export const addNewPayrollComponentDetailApi = (data) => api.post("/payroll-component-details", data);
export const updatePayrollComponentDetailApi = (data) => api.patch("/payroll-component-details", data);
export const deletePayrollComponentDetailApi = (data) => api.delete("/payroll-component-details", data);

export const getWorkGroupApi = (data) => api.get("/work-groups", data);
export const approveWorkGroupApi = (data) => api.put("/work-groups", data);
export const addNewWorkGroupApi = (data) => api.post("/work-groups", data);
export const updateWorkGroupApi = (data) => api.patch("/work-groups", data);
export const deleteWorkGroupApi = (data) => api.delete("/work-groups", data);

export const getWorkGroupDetailApi = (data) => api.get("/work-group-details", data);
export const approveWorkGroupDetailApi = (data) => api.put("/work-group-details", data);
export const addNewWorkGroupDetailApi = (data) => api.post("/work-group-details", data);
export const updateWorkGroupDetailApi = (data) => api.patch("/work-group-details", data);
export const deleteWorkGroupDetailApi = (data) => api.delete("/work-group-details", data);

export const getEmployeeTaxApi = (data) => api.get("/employee-taxes", data);
export const addNewEmployeeTaxApi = (data) => api.post("/employee-taxes", data);
export const updateEmployeeTaxApi = (data) => api.patch("/employee-taxes", data);
export const deleteEmployeeTaxApi = (data) => api.delete("/employee-taxes", data);
export const approveEmployeeTaxApi = (data) => api.put("/employee-taxes", data);

export const getPerformanceAppraisalDetailApi = (data) => api.get("/performance-appraisal-details", data);
export const approvePerformanceAppraisalDetailApi = (data) => api.put("/performance-appraisal-details", data);
export const addNewPerformanceAppraisalDetailApi = (data) => api.post("/performance-appraisal-details", data);
export const updatePerformanceAppraisalDetailApi = (data) => api.patch("/performance-appraisal-details", data);
export const deletePerformanceAppraisalDetailApi = (data) => api.delete("/performance-appraisal-details", data);

export const getPerformanceAppraisalApi = (data) => api.get("/performance-appraisals", data);
export const approvePerformanceAppraisalApi = (data) => api.put("/performance-appraisals", data);
export const addNewPerformanceAppraisalApi = (data) => api.post("/performance-appraisals", data);
export const updatePerformanceAppraisalApi = (data) => api.patch("/performance-appraisals", data);
export const deletePerformanceAppraisalApi = (data) => api.delete("/performance-appraisals", data);

export const getPerformanceApi = (data) => api.get("/performances", data);
export const approvePerformanceApi = (data) => api.put("/performances", data);
export const addNewPerformanceApi = (data) => api.post("/performances", data);
export const updatePerformanceApi = (data) => api.patch("/performances", data);
export const deletePerformanceApi = (data) => api.delete("/performances", data);

export const getPerformancePredicateApi = (data) => api.get("/performance-predicates", data);
export const approvePerformancePredicateApi = (data) => api.put("/performance-predicates", data);
export const addNewPerformancePredicateApi = (data) => api.post("/performance-predicates", data);
export const updatePerformancePredicateApi = (data) => api.patch("/performance-predicates", data);
export const deletePerformancePredicateApi = (data) => api.delete("/performance-predicates", data);

export const getPerformanceScoreApi = (data) => api.get("/performance-scores", data);
export const approvePerformanceScoreApi = (data) => api.put("/performance-scores", data);
export const addNewPerformanceScoreApi = (data) => api.post("/performance-scores", data);
export const updatePerformanceScoreApi = (data) => api.patch("/performance-scores", data);
export const deletePerformanceScoreApi = (data) => api.delete("/performance-scores", data);

export const getPerformanceScoreDetailApi = (data) => api.get("/performance-score-details", data);
export const approvePerformanceScoreDetailApi = (data) => api.put("/performance-score-details", data);
export const addNewPerformanceScoreDetailApi = (data) => api.post("/performance-score-details", data);
export const updatePerformanceScoreDetailApi = (data) => api.patch("/performance-score-details", data);
export const deletePerformanceScoreDetailApi = (data) => api.delete("/performance-score-details", data);

export const getEmployeeAssessmentDetailApi = (data) => api.get("/employee-assessment-details", data);
export const approveEmployeeAssessmentDetailApi = (data) => api.put("/employee-assessment-details", data);
export const addNewEmployeeAssessmentDetailApi = (data) => api.post("/employee-assessment-details", data);
export const updateEmployeeAssessmentDetailApi = (data) => api.patch("/employee-assessment-details", data);
export const deleteEmployeeAssessmentDetailApi = (data) => api.delete("/employee-assessment-details", data);

export const getEmployeeAssessmentApi = (data) => api.get("/employee-assessments", data);
export const approveEmployeeAssessmentApi = (data) => api.put("/employee-assessments", data);
export const addNewEmployeeAssessmentApi = (data) => api.post("/employee-assessments", data);
export const updateEmployeeAssessmentApi = (data) => api.patch("/employee-assessments", data);
export const deleteEmployeeAssessmentApi = (data) => api.delete("/employee-assessments", data);

export const getTaskApi = (data) => api.get("/tasks", data);
export const getPublicSalesApi = (data) => api.get("/sales-public", data);
export const approveTaskApi = (data) => api.put("/tasks", data);
export const addNewTaskApi = (data) => api.post("/tasks", data);
export const updateTaskApi = (data) => api.patch("/tasks", data);
export const deleteTaskApi = (data) => api.delete("/tasks", data);

export const getTaskDetailApi = (data) => api.get("/task-details", data);
export const approveTaskDetailApi = (data) => api.put("/task-details", data);
export const addNewTaskDetailApi = (data) => api.post("/task-details", data);
export const updateTaskDetailApi = (data) => api.patch("/task-details", data);
export const deleteTaskDetailApi = (data) => api.delete("/task-details", data);

export const getTaskListDetailApi = (data) => api.get("/task-list-details", data);
export const approveTaskListDetailApi = (data) => api.put("/task-list-details", data);
export const addNewTaskListDetailApi = (data) => api.post("/task-list-details", data);
export const updateTaskListDetailApi = (data) => api.patch("/task-list-details", data);
export const deleteTaskListDetailApi = (data) => api.delete("/task-list-details", data);

export const getTaskListApi = (data) => api.get(`/task-lists`, data);
export const approveTaskListApi = (data) => api.put("/task-lists", data);
export const addNewTaskListApi = (data) => api.post("/task-lists", data);
export const updateTaskListApi = (data) => api.patch("/task-lists", data);
export const deleteTaskListApi = (data) => api.delete("/task-lists", data);

export const getTicketApi = (data) => api.get("/tickets", data);
export const approveTicketApi = (data) => api.put("/tickets", data);
export const addNewTicketApi = (data) => api.post("/tickets", data);
export const updateTicketApi = (data) => api.patch("/tickets", data);
export const deleteTicketApi = (data) => api.delete("/tickets", data);

export const getTicketCategoryApi = (data) => api.get("/ticket-categories", data);
export const addNewTicketCategoryApi = (data) => api.post("/ticket-categories", data);
export const approveTicketCategoryApi = (data) => api.put("/ticket-categories", data);
export const updateTicketCategoryApi = (data) => api.patch("/ticket-categories", data);
export const deleteTicketCategoryApi = (data) => api.delete("/ticket-categories", data);

export const getTaskCategoryApi = (data) => api.get("/task-categories", data);
export const addNewTaskCategoryApi = (data) => api.post("/task-categories", data);
export const approveTaskCategoryApi = (data) => api.put("/task-categories", data);
export const updateTaskCategoryApi = (data) => api.patch("/task-categories", data);
export const deleteTaskCategoryApi = (data) => api.delete("/task-categories", data);

export const getLoanTermApi = (data) => api.get("/loan-terms", data);
export const approveLoanTermApi = (data) => api.put("/loan-terms", data);
export const addNewLoanTermApi = (data) => api.post("/loan-terms", data);
export const updateLoanTermApi = (data) => api.patch("/loan-terms", data);
export const deleteLoanTermApi = (data) => api.delete("/loan-terms", data);

export const getLoanApi = (data) => api.get("/loans", data);
export const approveLoanApi = (data) => api.put("/loans", data);
export const addNewLoanApi = (data) => api.post("/loans", data);
export const updateLoanApi = (data) => api.patch("/loans", data);
export const deleteLoanApi = (data) => api.delete("/loans", data);

//pelunasan

export const getReimbursementTypeApi = (data) => api.get("/reimbursement-types", data);
export const approveReimbursementTypeApi = (data) => api.put("/reimbursement-types", data);
export const addNewReimbursementTypeApi = (data) => api.post("/reimbursement-types", data);
export const updateReimbursementTypeApi = (data) => api.patch("/reimbursement-types", data);
export const deleteReimbursementTypeApi = (data) => api.delete("/reimbursement-types", data);

export const getReimbursementApi = (data) => api.get("/reimbursements", data);
export const approveReimbursementApi = (data) => api.put("/reimbursements", data);
export const addNewReimbursementApi = (data) => api.post("/reimbursements", data);
export const updateReimbursementApi = (data) => api.patch("/reimbursements", data);
export const deleteReimbursementApi = (data) => api.delete("/reimbursements", data);

//Inventory
export const getProductApi = (data) => api.get("/products", data);
export const approveProductApi = (data) => api.put("/products", data);
export const addNewProductApi = (data) => api.post("/products", data);
export const updateProductApi = (data) => api.patch("/products", data);
export const deleteProductApi = (data) => api.delete("/products", data);

export const getProductCategoryApi = (data) => api.get("/product-categories", data);
export const addNewProductCategoryApi = (data) => api.post("/product-categories", data);
export const updateProductCategoryApi = (data) => api.patch("/product-categories", data);
export const deleteProductCategoryApi = (data) => api.delete("/product-categories", data);

export const getProductBlockApi = (data) => api.get("/product-blocks", data);
export const approveProductBlockApi = (data) => api.put("/product-blocks", data);
export const addNewProductBlockApi = (data) => api.post("/product-blocks", data);
export const updateProductBlockApi = (data) => api.patch("/product-blocks", data);
export const deleteProductBlockApi = (data) => api.delete("/product-blocks", data);

export const getProductOptionApi = (data) => api.get("/product-options", data);
export const approveProductOptionApi = (data) => api.put("/product-options", data);
export const addNewProductOptionApi = (data) => api.post("/product-options", data);
export const updateProductOptionApi = (data) => api.patch("/product-options", data);
export const deleteProductOptionApi = (data) => api.delete("/product-options", data);

export const getProductOptionDetailApi = (data) => api.get("/product-option-details", data);
export const approveProductOptionDetailApi = (data) => api.put("/product-option-details", data);
export const addNewProductOptionDetailApi = (data) => api.post("/product-option-details", data);
export const updateProductOptionDetailApi = (data) => api.patch("/product-option-details", data);
export const deleteProductOptionDetailApi = (data) => api.delete("/product-option-details", data);

export const getProductVarianApi = (data) => api.get("/product-varians", data);
export const addNewProductVarianApi = (data) => api.post("/product-varians", data);
export const updateProductVarianApi = (data) => api.patch("/product-varians", data);
export const deleteProductVarianApi = (data) => api.delete("/product-varians", data);

export const getProductTagApi = (data) => api.get("/product-tags", data);
export const approveProductTagApi = (data) => api.put("/product-tags", data);
export const addNewProductTagApi = (data) => api.post("/product-tags", data);
export const updateProductTagApi = (data) => api.patch("/product-tags", data);
export const deleteProductTagApi = (data) => api.delete("/product-tags", data);

export const getProductTypeApi = (data) => api.get("/product-types", data);
export const approveProductTypeApi = (data) => api.put("/product-types", data);
export const addNewProductTypeApi = (data) => api.post("/product-types", data);
export const updateProductTypeApi = (data) => api.patch("/product-types", data);
export const deleteProductTypeApi = (data) => api.delete("/product-types", data);

export const getProductInventoryApi = (data) => api.get("/product-inventories", data);
export const approveProductInventoryApi = (data) => api.put("/product-inventories", data);
export const addNewProductInventoryApi = (data) => api.post("/product-inventories", data);
export const updateProductInventoryApi = (data) => api.patch("/product-inventories", data);
export const deleteProductInventoryApi = (data) => api.delete("/product-inventories", data);

export const getProductInventoryDetailApi = (data) => api.get("/product-inventory-details", data);
export const approveProductInventoryDetailApi = (data) => api.put("/product-inventory-details", data);
export const addNewProductInventoryDetailApi = (data) => api.post("/product-inventory-details", data);
export const updateProductInventoryDetailApi = (data) => api.patch("/product-inventory-details", data);
export const deleteProductInventoryDetailApi = (data) => api.delete("/product-inventory-details", data);

export const getProductInventoryBranchApi = (data) => api.get("/product-inventory-branches", data);
export const approveProductInventoryBranchApi = (data) => api.put("/product-inventory-branches", data);
export const addNewProductInventoryBranchApi = (data) => api.post("/product-inventory-branches", data);
export const updateProductInventoryBranchApi = (data) => api.patch("/product-inventory-branches", data);
export const deleteProductInventoryBranchApi = (data) => api.delete("/product-inventory-branches", data);

export const getProductHandoverApi = (data) => api.get("/product-handovers", data);
export const addNewProductHandoverApi = (data) => api.post("/product-handovers", data);
export const updateProductHandoverApi = (data) => api.patch("/product-handovers", data);
export const deleteProductHandoverApi = (data) => api.delete("/product-handovers", data);
export const approveProductHandoverApi = (data) => api.put("/product-handovers", data);

export const getProductComplainApi = (data) => api.get("/product-complains", data);
export const addNewProductComplainApi = (data) => api.post("/product-complains", data);
export const updateProductComplainApi = (data) => api.patch("/product-complains", data);
export const deleteProductComplainApi = (data) => api.delete("/product-complains", data);
export const approveProductComplainApi = (data) => api.put("/product-complains", data);

//Asset
export const getAssetApi = (data) => api.get("/assets", data);
export const approveAssetApi = (data) => api.put("/assets", data);
export const addNewAssetApi = (data) => api.post("/assets", data);
export const updateAssetApi = (data) => api.patch("/assets", data);
export const deleteAssetApi = (data) => api.delete("/assets", data);

export const getAssetInspectionApi = (data) => api.get("/asset-inspections", data);
export const approveAssetInspectionApi = (data) => api.put("/asset-inspections", data);
export const addNewAssetInspectionApi = (data) => api.post("/asset-inspections", data);
export const updateAssetInspectionApi = (data) => api.patch("/asset-inspections", data);
export const deleteAssetInspectionApi = (data) => api.delete("/asset-inspections", data);

export const getAssetInspectionCategoryApi = (data) => api.get("/asset-inspection-categories", data);
export const approveAssetInspectionCategoryApi = (data) => api.put("/asset-inspection-categories", data);
export const addNewAssetInspectionCategoryApi = (data) => api.post("/asset-inspection-categories", data);
export const updateAssetInspectionCategoryApi = (data) => api.patch("/asset-inspection-categories", data);
export const deleteAssetInspectionCategoryApi = (data) => api.delete("/asset-inspection-categories", data);

export const getAssetTagApi = (data) => api.get("/asset-tags", data);
export const approveAssetTagApi = (data) => api.put("/asset-tags", data);
export const addNewAssetTagApi = (data) => api.post("/asset-tags", data);
export const updateAssetTagApi = (data) => api.patch("/asset-tags", data);
export const deleteAssetTagApi = (data) => api.delete("/asset-tags", data);

export const getUomApi = (data) => api.get("/uoms", data);
export const approveUomApi = (data) => api.put("/uoms", data);
export const addNewUomApi = (data) => api.post("/uoms", data);
export const updateUomApi = (data) => api.patch("/uoms", data);
export const deleteUomApi = (data) => api.delete("/uoms", data);

export const getAccAccountApi = (data) => api.get("/acc-accounts", data);
export const getOneAccAccountApi = (data) => api.getOne("/acc-accounts", data);
export const approveAccAccountApi = (data) => api.put("/acc-accounts", data);
export const addNewAccAccountApi = (data) => api.post("/acc-accounts", data);
export const updateAccAccountApi = (data) => api.patch("/acc-accounts", data);
export const deleteAccAccountApi = (data) => api.delete("/acc-accounts", data);

export const getAccTagApi = (data) => api.get("/acc-tags", data);
export const approveAccTagApi = (data) => api.put("/acc-tags", data);
export const addNewAccTagApi = (data) => api.post("/acc-tags", data);
export const updateAccTagApi = (data) => api.patch("/acc-tags", data);
export const deleteAccTagApi = (data) => api.delete("/acc-tags", data);

export const getAccAccountCloseApi = (data) => api.get("/acc-account-closes", data);
export const approveAccAccountCloseApi = (data) => api.put("/acc-account-closes", data);
export const addNewAccAccountCloseApi = (data) => api.post("/acc-account-closes", data);
export const updateAccAccountCloseApi = (data) => api.patch("/acc-account-closes", data);
export const deleteAccAccountCloseApi = (data) => api.delete("/acc-account-closes", data);

export const getAccTransApi = (data) => api.get("/acc-transactions", data);
export const getOneAccTransApi = (data) => api.getOne("/acc-transactions", data);
export const approveAccTransApi = (data) => api.put("/acc-transactions", data);
export const addNewAccTransApi = (data) => api.post("/acc-transactions", data);
export const updateAccTransApi = (data) => api.patch("/acc-transactions", data);
export const deleteAccTransApi = (data) => api.delete("/acc-transactions", data);

export const getAccReleaseTransApi = (data) => api.get("/acc-release-transactions", data);
export const getOneAccReleaseTransApi = (data) => api.getOne("/acc-release-transactions", data);
export const approveAccReleaseTransApi = (data) => api.put("/acc-release-transactions", data);
export const addNewAccReleaseTransApi = (data) => api.post("/acc-release-transactions", data);
export const updateAccReleaseTransApi = (data) => api.patch("/acc-release-transactions", data);
export const deleteAccReleaseTransApi = (data) => api.delete("/acc-release-transactions", data);

export const getAccCategoryApi = (data) => api.get("/acc-categories", data);
export const approveAccCategoryApi = (data) => api.put("/acc-categories", data);
export const addNewAccCategoryApi = (data) => api.post("/acc-categories", data);
export const updateAccCategoryApi = (data) => api.patch("/acc-categories", data);
export const deleteAccCategoryApi = (data) => api.delete("/acc-categories", data);

export const getAssetClassApi = (data) => api.get("/asset-classes", data);
export const approveAssetClassApi = (data) => api.put("/asset-classes", data);
export const addNewAssetClassApi = (data) => api.post("/asset-classes", data);
export const updateAssetClassApi = (data) => api.patch("/asset-classes", data);
export const deleteAssetClassApi = (data) => api.delete("/asset-classes", data);

export const getAssetCategoryApi = (data) => api.get("/asset-categories", data);
export const addNewAssetCategoryApi = (data) => api.post("/asset-categories", data);
export const updateAssetCategoryApi = (data) => api.patch("/asset-categories", data);
export const deleteAssetCategoryApi = (data) => api.delete("/asset-categories", data);

////TRANSACTION METHOD
export const getPaymentMethodApi = (data) => api.get("/payment-methods", data);
export const approvePaymentMethodApi = (data) => api.put("/payment-methods", data);
export const addNewPaymentMethodApi = (data) => api.post("/payment-methods", data);
export const updatePaymentMethodApi = (data) => api.patch("/payment-methods", data);
export const deletePaymentMethodApi = (data) => api.delete("/payment-methods", data);

export const getPaymentTermApi = (data) => api.get("/payment-terms", data);
export const approvePaymentTermApi = (data) => api.put("/payment-terms", data);
export const addNewPaymentTermApi = (data) => api.post("/payment-terms", data);
export const updatePaymentTermApi = (data) => api.patch("/payment-terms", data);
export const deletePaymentTermApi = (data) => api.delete("/payment-terms", data);

export const getShipmentMethodApi = (data) => api.get("/shipment-methods", data);
export const approveShipmentMethodApi = (data) => api.put("/shipment-methods", data);
export const addNewShipmentMethodApi = (data) => api.post("/shipment-methods", data);
export const updateShipmentMethodApi = (data) => api.patch("/shipment-methods", data);
export const deleteShipmentMethodApi = (data) => api.delete("/shipment-methods", data);

export const getShipmentCarrierApi = (data) => api.get("/shipment-carriers", data);
export const approveShipmentCarrierApi = (data) => api.put("/shipment-carriers", data);
export const addNewShipmentCarrierApi = (data) => api.post("/shipment-carriers", data);
export const updateShipmentCarrierApi = (data) => api.patch("/shipment-carriers", data);
export const deleteShipmentCarrierApi = (data) => api.delete("/shipment-carriers", data);

export const getTransactionTaxApi = (data) => api.get("/transaction-taxes", data);
export const approveTransactionTaxApi = (data) => api.put("/transaction-taxes", data);
export const addNewTransactionTaxApi = (data) => api.post("/transaction-taxes", data);
export const updateTransactionTaxApi = (data) => api.patch("/transaction-taxes", data);
export const deleteTransactionTaxApi = (data) => api.delete("/transaction-taxes", data);

//Purchase
export const getVendorApi = (data) => api.get("/vendors", data);
export const addNewVendorApi = (data) => api.post("/vendors", data);
export const approveVendorApi = (data) => api.put("/vendors", data);
export const updateVendorApi = (data) => api.patch("/vendors", data);
export const deleteVendorApi = (data) => api.delete("/vendors", data);

export const getPurchaseApi = (data) => api.get("/purchases", data);
export const approvePurchaseApi = (data) => api.put("/purchases", data);
export const addNewPurchaseApi = (data) => api.post("/purchases", data);
export const updatePurchaseApi = (data) => api.patch("/purchases", data);
export const deletePurchaseApi = (data) => api.delete("/purchases", data);

export const getPurchaseDetailApi = (data) => api.get("/purchase-details", data);
export const approvePurchaseDetailApi = (data) => api.put("/purchase-details", data);
export const addNewPurchaseDetailApi = (data) => api.post("/purchase-details", data);
export const updatePurchaseDetailApi = (data) => api.patch("/purchase-details", data);
export const deletePurchaseDetailApi = (data) => api.delete("/purchase-details", data);

export const getLegalApi = (data) => api.get("/legals", data);
export const approveLegalApi = (data) => api.put("/legals", data);
export const addNewLegalApi = (data) => api.post("/legals", data);
export const updateLegalApi = (data) => api.patch("/legals", data);
export const deleteLegalApi = (data) => api.delete("/legals", data);

export const getLegalMasterApi = (data) => api.get("/legal-masters", data);
export const approveLegalMasterApi = (data) => api.put("/legal-masters", data);
export const addNewLegalMasterApi = (data) => api.post("/legal-masters", data);
export const updateLegalMasterApi = (data) => api.patch("/legal-masters", data);
export const deleteLegalMasterApi = (data) => api.delete("/legal-masters", data);

export const getLegalStatusApi = (data) => api.get("/legal-status", data);
export const approveLegalStatusApi = (data) => api.put("/legal-status", data);
export const addNewLegalStatusApi = (data) => api.post("/legal-status", data);
export const updateLegalStatusApi = (data) => api.patch("/legal-status", data);
export const deleteLegalStatusApi = (data) => api.delete("/legal-status", data);

export const getPurchaseHistoryApi = (data) => api.get("/purchase-histories", data);
export const approvePurchaseHistoryApi = (data) => api.put("/purchase-histories", data);
export const addNewPurchaseHistoryApi = (data) => api.post("/purchase-histories", data);
export const updatePurchaseHistoryApi = (data) => api.patch("/purchase-histories", data);
export const deletePurchaseHistoryApi = (data) => api.delete("/purchase-histories", data);

//Sales
export const getCustomerApi = (data) => api.get("/customers", data);
export const addNewCustomerApi = (data) => api.post("/customers", data);
export const approveCustomerApi = (data) => api.put("/customers", data);
export const updateCustomerApi = (data) => api.patch("/customers", data);
export const deleteCustomerApi = (data) => api.delete("/customers", data);

export const getApplicantApi = (data) => api.get("/applicants", data);
export const getOneApplicantApi = (data) => api.getOne("/applicants", data);
export const addNewApplicantApi = (data) => api.post("/applicants", data);
export const approveApplicantApi = (data) => api.put("/applicants", data);
export const updateApplicantApi = (data) => api.patch("/applicants", data);
export const deleteApplicantApi = (data) => api.delete("/applicants", data);

export const getTransactionApi = (data) => api.get("/transactions", data);
export const getOneTransactionApi = (data) => api.getOne("/transactions", data);
export const addNewTransactionApi = (data) => api.post("/transactions", data);
export const approveTransactionApi = (data) => api.put("/transactions", data);
export const updateTransactionApi = (data) => api.patch("/transactions", data);
export const deleteTransactionApi = (data) => api.delete("/transactions", data);

export const getCustomerGroupApi = (data) => api.get("/customer-groups", data);
export const addNewCustomerGroupApi = (data) => api.post("/customer-groups", data);
export const approveCustomerGroupApi = (data) => api.put("/customer-groups", data);
export const updateCustomerGroupApi = (data) => api.patch("/customer-groups", data);
export const deleteCustomerGroupApi = (data) => api.delete("/customer-groups", data);

export const getSalesApi = (data) => api.get("/sales", data);
export const getOneSalesApi = (data) => api.getOne("/sales", data);
export const approveSalesApi = (data) => api.put("/sales", data);
export const addNewSalesApi = (data) => api.post("/sales", data);
export const updateSalesApi = (data) => api.patch("/sales", data);
export const deleteSalesApi = (data) => api.delete("/sales", data);

export const getSalesPublicApi = (data) => api.get("/sales-publics", data);
export const getOneSalesPublicApi = (data) => api.getOne("/sales-publics", data);
export const approveSalesPublicApi = (data) => api.put("/sales-publics", data);
export const addNewSalesPublicApi = (data) => api.post("/sales-publics", data);
export const updateSalesPublicApi = (data) => api.patch("/sales-publics", data);
export const deleteSalesPublicApi = (data) => api.delete("/sales-publics", data);

export const getSalesBookApi = (data) => api.get("/sales-books", data);
export const approveSalesBookApi = (data) => api.put("/sales-books", data);
export const addNewSalesBookApi = (data) => api.post("/sales-books", data);
export const updateSalesBookApi = (data) => api.patch("/sales-books", data);
export const deleteSalesBookApi = (data) => api.delete("/sales-books", data);

export const getSalesPromoApi = (data) => api.get("/sales-promos", data);
export const approveSalesPromoApi = (data) => api.put("/sales-promos", data);
export const addNewSalesPromoApi = (data) => api.post("/sales-promos", data);
export const updateSalesPromoApi = (data) => api.patch("/sales-promos", data);
export const deleteSalesPromoApi = (data) => api.delete("/sales-promos", data);

export const getSalesDetailApi = (data) => api.get("/sales-details", data);
export const approveSalesDetailApi = (data) => api.put("/sales-details", data);
export const addNewSalesDetailApi = (data) => api.post("/sales-details", data);
export const updateSalesDetailApi = (data) => api.patch("/sales-details", data);
export const deleteSalesDetailApi = (data) => api.delete("/sales-details", data);

export const getMarketingApi = (data) => api.get("/marketing", data);
export const approveMarketingApi = (data) => api.put("/marketing", data);
export const addNewMarketingApi = (data) => api.post("/marketing", data);
export const updateMarketingApi = (data) => api.patch("/marketing", data);
export const deleteMarketingApi = (data) => api.delete("/marketing", data);

export const getSalesPaymentApi = (data) => api.get("/sales-payments", data);
export const approveSalesPaymentApi = (data) => api.put("/sales-payments", data);
export const addNewSalesPaymentApi = (data) => api.post("/sales-payments", data);
export const updateSalesPaymentApi = (data) => api.patch("/sales-payments", data);
export const deleteSalesPaymentApi = (data) => api.delete("/sales-payments", data);

export const getSalesHistoryApi = (data) => api.get("/sales-histories", data);
export const approveSalesHistoryApi = (data) => api.put("/sales-histories", data);
export const addNewSalesHistoryApi = (data) => api.post("/sales-histories", data);
export const updateSalesHistoryApi = (data) => api.patch("/sales-histories", data);
export const deleteSalesHistoryApi = (data) => api.delete("/sales-histories", data);

export const getSalesWarrantyApi = (data) => api.get("/sales-warranties", data);
export const approveSalesWarrantyApi = (data) => api.put("/sales-warranties", data);
export const addNewSalesWarrantyApi = (data) => api.post("/sales-warranties", data);
export const updateSalesWarrantyApi = (data) => api.patch("/sales-warranties", data);
export const deleteSalesWarrantyApi = (data) => api.delete("/sales-warranties", data);

export const getSalesChannelApi = (data) => api.get("/sales-channels", data);
export const approveSalesChannelApi = (data) => api.put("/sales-channels", data);
export const addNewSalesChannelApi = (data) => api.post("/sales-channels", data);
export const updateSalesChannelApi = (data) => api.patch("/sales-channels", data);
export const deleteSalesChannelApi = (data) => api.delete("/sales-channels", data);

export const getSalesTypeApi = (data) => api.get("/sales-types", data);
export const approveSalesTypeApi = (data) => api.put("/sales-types", data);
export const addNewSalesTypeApi = (data) => api.post("/sales-types", data);
export const updateSalesTypeApi = (data) => api.patch("/sales-types", data);
export const deleteSalesTypeApi = (data) => api.delete("/sales-types", data);

export const getSalesTargetApi = (data) => api.get("/sales-targets", data);
export const approveSalesTargetApi = (data) => api.put("/sales-targets", data);
export const addNewSalesTargetApi = (data) => api.post("/sales-targets", data);
export const updateSalesTargetApi = (data) => api.patch("/sales-targets", data);
export const deleteSalesTargetApi = (data) => api.delete("/sales-targets", data);

export const getCampaignApi = (data) => api.get("/campaigns", data);
export const approveCampaignApi = (data) => api.put("/campaigns", data);
export const addNewCampaignApi = (data) => api.post("/campaigns", data);
export const updateCampaignApi = (data) => api.patch("/campaigns", data);
export const deleteCampaignApi = (data) => api.delete("/campaigns", data);

export const getCampaignDetailApi = (data) => api.get("/campaign-details", data);
export const approveCampaignDetailApi = (data) => api.put("/campaign-details", data);
export const addNewCampaignDetailApi = (data) => api.post("/campaign-details", data);
export const updateCampaignDetailApi = (data) => api.patch("/campaign-details", data);
export const deleteCampaignDetailApi = (data) => api.delete("/campaign-details", data);

export const getCampaignPageApi = (data) => api.get(`/campaign-pages`, data);
export const addNewCampaignPageApi = (data) => api.post(`/campaign-pages`, data);
export const updateCampaignPageApi = (data) => api.patch(`/campaign-pages`, data);
export const deleteCampaignPageApi = (data) => api.delete(`/campaign-pages`, data);

//Inventory
export const getTransferApi = (data) => api.get("/product-transfers", data);
export const approveTransferApi = (data) => api.put("/product-transfers", data);
export const addNewTransferApi = (data) => api.post("/product-transfers", data);
export const updateTransferApi = (data) => api.patch("/product-transfers", data);
export const deleteTransferApi = (data) => api.delete("/product-transfers", data);

export const getTransferDetailApi = (data) => api.get("/product-transfer-details", data);
export const approveTransferDetailApi = (data) => api.put("/product-transfer-details", data);
export const addNewTransferDetailApi = (data) => api.post("/product-transfer-details", data);
export const updateTransferDetailApi = (data) => api.patch("/product-transfer-details", data);
export const deleteTransferDetailApi = (data) => api.delete("/product-transfer-details", data);

export const getTransferHistoryApi = (data) => api.get("/product-transfer-histories", data);
export const approveTransferHistoryApi = (data) => api.put("/product-transfer-histories", data);
export const addNewTransferHistoryApi = (data) => api.post("/product-transfer-histories", data);
export const updateTransferHistoryApi = (data) => api.patch("/product-transfer-histories", data);
export const deleteTransferHistoryApi = (data) => api.delete("/product-transfer-histories", data);

//ROLE
export const getRoleApi = (data) => api.get("/roles", data);
export const addNewRoleApi = (data) => api.post("/roles", data);
export const updateRoleApi = (data) => api.patch("/roles", data);
export const deleteRoleApi = (data) => api.delete("/roles", data);
export const approveRoleApi = (data) => api.put("/roles", data);

export const getRoleListApi = (data) => api.get("/role-lists", data);
export const addNewRoleListApi = (data) => api.post("/role-lists", data);
export const updateRoleListApi = (data) => api.patch("/role-lists", data);
export const deleteRoleListApi = (data) => api.delete("/role-lists", data);
export const approveRoleListApi = (data) => api.put("/role-lists", data);

export const getOneUserApi = (id) => api.getOne("/users", id);
export const getUserApi = (data) => api.get(`/users`, data);
export const addNewUserApi = (data) => api.post(`/users`, data);
export const updateUserApi = (data) => api.patch(`/users`, data);
export const deleteUserApi = (data) => api.delete(`/users`, data);
export const approveUserApi = (data) => api.put(`/users`, data);

export const getServiceApi = (data) => api.get(`/services`, data);
export const addNewServiceApi = (data) => api.post(`/services`, data);
export const updateServiceApi = (data) => api.patch(`/services`, data);
export const deleteServiceApi = (data) => api.delete(`/services`, data);
export const approveServiceApi = (data) => api.put(`/services`, data);

export const getOneStorageFileApi = (id) => api.getOne(`${url.MEDIA_URL}/storage-files`, id);
export const getStorageFileApi = (data) => api.get(`${url.MEDIA_URL}/storage-files`, data);
export const addNewStorageFileApi = (data) => api.postImg(`${url.MEDIA_URL}/storage-files`, data);
export const approveStorageFileApi = (data) => api.put(`${url.MEDIA_URL}/storage-files`, data);
export const updateStorageFileApi = (data) => api.patch(`${url.MEDIA_URL}/storage-files`, data);
export const deleteStorageFileApi = (data) => api.delete(`${url.MEDIA_URL}/storage-files`, data);

export const getOneStorageFolderApi = (id) => api.getOne(`${url.MEDIA_URL}/storage-folders`, id);
export const getStorageFolderApi = (data) => api.get(`${url.MEDIA_URL}/storage-folders`, data);
export const addNewStorageFolderApi = (data) => api.post(`${url.MEDIA_URL}/storage-folders`, data);
export const approveStorageFolderApi = (data) => api.put(`${url.MEDIA_URL}/storage-folders`, data);
export const updateStorageFolderApi = (data) => api.patch(`${url.MEDIA_URL}/storage-folders`, data);
export const deleteStorageFolderApi = (data) => api.delete(`${url.MEDIA_URL}/storage-folders`, data);

export const getOneStorageMoveApi = (id) => api.getOne(`${url.MEDIA_URL}/storage-moves`, id);
export const getStorageMoveApi = (data) => api.get(`${url.MEDIA_URL}/storage-moves`, data);
export const addNewStorageMoveApi = (data) => api.post(`${url.MEDIA_URL}/storage-moves`, data);
export const approveStorageMoveApi = (data) => api.put(`${url.MEDIA_URL}/storage-moves`, data);
export const updateStorageMoveApi = (data) => api.patch(`${url.MEDIA_URL}/storage-moves`, data);
export const deleteStorageMoveApi = (data) => api.delete(`${url.MEDIA_URL}/storage-moves`, data);

export const getOneStorageRenameApi = (id) => api.getOne(`${url.MEDIA_URL}/storage-renames`, id);
export const getStorageRenameApi = (data) => api.get(`${url.MEDIA_URL}/storage-renames`, data);
export const addNewStorageRenameApi = (data) => api.post(`${url.MEDIA_URL}/storage-renames`, data);
export const approveStorageRenameApi = (data) => api.put(`${url.MEDIA_URL}/storage-renames`, data);
export const updateStorageRenameApi = (data) => api.patch(`${url.MEDIA_URL}/storage-renames`, data);
export const deleteStorageRenameApi = (data) => api.delete(`${url.MEDIA_URL}/storage-renames`, data);

export const getContactApi = (data) => api.get("/customer-contacts", data);
export const approveContactApi = (data) => api.put("/customer-contacts", data);
export const addNewContactApi = (data) => api.post("/customer-contacts", data);
export const updateContactApi = (data) => api.patch("/customer-contacts", data);
export const deleteContactApi = (data) => api.delete("/customer-contacts", data);

export const getMarketApi = (data) => api.get("/markets", data);
export const approveMarketApi = (data) => api.put("/markets", data);
export const addNewMarketApi = (data) => api.post("/markets", data);
export const updateMarketApi = (data) => api.patch("/markets", data);
export const deleteMarketApi = (data) => api.delete("/markets", data);

export const getDealApi = (data) => api.get("/deals", data);
export const approveDealApi = (data) => api.put("/deals", data);
export const addNewDealApi = (data) => api.post("/deals", data);
export const updateDealApi = (data) => api.patch("/deals", data);
export const deleteDealApi = (data) => api.delete("/deals", data);

export const getDealTagApi = (data) => api.get("/deal-tags", data);
export const approveDealTagApi = (data) => api.put("/deal-tags", data);
export const addNewDealTagApi = (data) => api.post("/deal-tags", data);
export const updateDealTagApi = (data) => api.patch("/deal-tags", data);
export const deleteDealTagApi = (data) => api.delete("/deal-tags", data);

export const getDealStatusApi = (data) => api.get("/deal-status", data);
export const approveDealStatusApi = (data) => api.put("/deal-status", data);
export const addNewDealStatusApi = (data) => api.post("/deal-status", data);
export const updateDealStatusApi = (data) => api.patch("/deal-status", data);
export const deleteDealStatusApi = (data) => api.delete("/deal-status", data);

export const getCreditOptionApi = (data) => api.get("/credit-options", data);
export const approveCreditOptionApi = (data) => api.put("/credit-options", data);
export const addNewCreditOptionApi = (data) => api.post("/credit-options", data);
export const updateCreditOptionApi = (data) => api.patch("/credit-options", data);
export const deleteCreditOptionApi = (data) => api.delete("/credit-options", data);

export const getCreditOptionDetailApi = (data) => api.get("/credit-option-details", data);
export const approveCreditOptionDetailApi = (data) => api.put("/credit-option-details", data);
export const addNewCreditOptionDetailApi = (data) => api.post("/credit-option-details", data);
export const updateCreditOptionDetailApi = (data) => api.patch("/credit-option-details", data);
export const deleteCreditOptionDetailApi = (data) => api.delete("/credit-option-details", data);

export const getSurveyApi = (data) => api.get("/surveys", data);
export const approveSurveyApi = (data) => api.put("/surveys", data);
export const addNewSurveyApi = (data) => api.post("/surveys", data);
export const updateSurveyApi = (data) => api.patch("/surveys", data);
export const deleteSurveyApi = (data) => api.delete("/surveys", data);

export const getSurveyScoreApi = (data) => api.get("/survey-scores", data);
export const approveSurveyScoreApi = (data) => api.put("/survey-scores", data);
export const addNewSurveyScoreApi = (data) => api.post("/survey-scores", data);
export const updateSurveyScoreApi = (data) => api.patch("/survey-scores", data);
export const deleteSurveyScoreApi = (data) => api.delete("/survey-scores", data);

export const getSurveyTemplateApi = (data) => api.get("/survey-templates", data);
export const approveSurveyTemplateApi = (data) => api.put("/survey-templates", data);
export const addNewSurveyTemplateApi = (data) => api.post("/survey-templates", data);
export const updateSurveyTemplateApi = (data) => api.patch("/survey-templates", data);
export const deleteSurveyTemplateApi = (data) => api.delete("/survey-templates", data);

export const getSurveyTemplateDetailApi = (data) => api.get("/survey-template-details", data);
export const approveSurveyTemplateDetailApi = (data) => api.put("/survey-template-details", data);
export const addNewSurveyTemplateDetailApi = (data) => api.post("/survey-template-details", data);
export const updateSurveyTemplateDetailApi = (data) => api.patch("/survey-template-details", data);
export const deleteSurveyTemplateDetailApi = (data) => api.delete("/survey-template-details", data);

export const getAgentApi = (data) => api.get("/agents", data);
export const approveAgentApi = (data) => api.put("/agents", data);
export const addNewAgentApi = (data) => api.post("/agents", data);
export const updateAgentApi = (data) => api.patch("/agents", data);
export const deleteAgentApi = (data) => api.delete("/agents", data);

export const getAgencyApi = (data) => api.get("/agencies", data);
export const approveAgencyApi = (data) => api.put("/agencies", data);
export const addNewAgencyApi = (data) => api.post("/agencies", data);
export const updateAgencyApi = (data) => api.patch("/agencies", data);
export const deleteAgencyApi = (data) => api.delete("/agencies", data);

export const getContentApi = (data) => api.get("/contents", data);
export const approveContentApi = (data) => api.put("/contents", data);
export const addNewContentApi = (data) => api.post("/contents", data);
export const updateContentApi = (data) => api.patch("/contents", data);
export const deleteContentApi = (data) => api.delete("/contents", data);

export const getContentCategoryApi = (data) => api.get("/content-categories", data);
export const approveContentCategoryApi = (data) => api.put("/content-categories", data);
export const addNewContentCategoryApi = (data) => api.post("/content-categories", data);
export const updateContentCategoryApi = (data) => api.patch("/content-categories", data);
export const deleteContentCategoryApi = (data) => api.delete("/content-categories", data);

export const getDashboardApi = (data) => api.get("/dashboards", data);
export const addNewDashboardApi = (data) => api.post("/dashboards", data);
export const approveDashboardApi = (data) => api.put("/dashboards", data);
export const updateDashboardApi = (data) => api.patch("/dashboards", data);
export const deleteDashboardApi = (data) => api.delete("/dashboards", data);

export const getOneCatalogAvailableApi = (id) => api.getOne("/catalogs/available", id);
export const getOneCatalogApi = (id) => api.getOne("/catalogs", id);
export const getCatalogApi = (data) => api.get("/catalogs", data);
export const approveCatalogApi = (data) => api.put("/catalogs", data);
export const addNewCatalogApi = (data) => api.post("/catalogs", data);
export const updateCatalogApi = (data) => api.patch("/catalogs", data);
export const deleteCatalogApi = (data) => api.delete("/catalogs", data);

//civil-account-categories
export const getCivilAccountCategoryApi = (data) => api.get("/civil-account-categories", data);
export const addNewCivilAccountCategoryApi = (data) => api.post("/civil-account-categories", data);
export const updateCivilAccountCategoryApi = (data) => api.patch("/civil-account-categories", data);
export const approveCivilAccountCategoryApi = (data) => api.put("/civil-account-categories", data);
export const deleteCivilAccountCategoryApi = (data) => api.delete("/civil-account-categories", data);

//civil-operational-categories
export const getCivilOperationalCategoryApi = (data) => api.get("/civil-operational-categories", data);
export const addNewCivilOperationalCategoryApi = (data) => api.post("/civil-operational-categories", data);
export const updateCivilOperationalCategoryApi = (data) => api.patch("/civil-operational-categories", data);
export const approveCivilOperationalCategoryApi = (data) => api.put("/civil-operational-categories", data);
export const deleteCivilOperationalCategoryApi = (data) => api.delete("/civil-operational-categories", data);

//civil-accounts
export const getCivilAccountApi = (data) => api.get("/civil-accounts", data);
export const addNewCivilAccountApi = (data) => api.post("/civil-accounts", data);
export const updateCivilAccountApi = (data) => api.patch("/civil-accounts", data);
export const approveCivilAccountApi = (data) => api.put("/civil-accounts", data);
export const deleteCivilAccountApi = (data) => api.delete("/civil-accounts", data);

//civil-operational-accounts
export const getCivilOperationalAccountApi = (data) => api.get("/civil-operational-accounts", data);
export const addNewCivilOperationalAccountApi = (data) => api.post("/civil-operational-accounts", data);
export const updateCivilOperationalAccountApi = (data) => api.patch("/civil-operational-accounts", data);
export const approveCivilOperationalAccountApi = (data) => api.put("/civil-operational-accounts", data);
export const deleteCivilOperationalAccountApi = (data) => api.delete("/civil-operational-accounts", data);

//civil-budgets
export const getCivilBudgetApi = (data) => api.get("/civil-budgets", data);
export const addNewCivilBudgetApi = (data) => api.post("/civil-budgets", data);
export const updateCivilBudgetApi = (data) => api.patch("/civil-budgets", data);
export const approveCivilBudgetApi = (data) => api.put("/civil-budgets", data);
export const deleteCivilBudgetApi = (data) => api.delete("/civil-budgets", data);

export const getCivilProgressionApi = (data) => api.get("/civil-progressions", data);
export const addNewCivilProgressionApi = (data) => api.post("/civil-progressions", data);
export const updateCivilProgressionApi = (data) => api.patch("/civil-progressions", data);
export const approveCivilProgressionApi = (data) => api.put("/civil-progressions", data);
export const deleteCivilProgressionApi = (data) => api.delete("/civil-progressions", data);

export const getCivilOpnameApi = (data) => api.get("/civil-opnames", data);
export const addNewCivilOpnameApi = (data) => api.post("/civil-opnames", data);
export const updateCivilOpnameApi = (data) => api.patch("/civil-opnames", data);
export const approveCivilOpnameApi = (data) => api.put("/civil-opnames", data);
export const deleteCivilOpnameApi = (data) => api.delete("/civil-opnames", data);

export const getCivilContractApi = (data) => api.get("/civil-contracts", data);
export const addNewCivilContractApi = (data) => api.post("/civil-contracts", data);
export const updateCivilContractApi = (data) => api.patch("/civil-contracts", data);
export const approveCivilContractApi = (data) => api.put("/civil-contracts", data);
export const deleteCivilContractApi = (data) => api.delete("/civil-contracts", data);

//civil-budget-details
export const getCivilBudgetDetailApi = (data) => api.get("/civil-budget-details", data);
export const addNewCivilBudgetDetailApi = (data) => api.post("/civil-budget-details", data);
export const updateCivilBudgetDetailApi = (data) => api.patch("/civil-budget-details", data);
export const approveCivilBudgetDetailApi = (data) => api.put("/civil-budget-details", data);
export const deleteCivilBudgetDetailApi = (data) => api.delete("/civil-budget-details", data);

export const getCivilBudgetControlApi = (data) => api.get("/civil-budget-controls", data);
export const addNewCivilBudgetControlApi = (data) => api.post("/civil-budget-controls", data);
export const updateCivilBudgetControlApi = (data) => api.patch("/civil-budget-controls", data);
export const approveCivilBudgetControlApi = (data) => api.put("/civil-budget-controls", data);
export const deleteCivilBudgetControlApi = (data) => api.delete("/civil-budget-controls", data);

export const getCivilBudgetControlMaterialApi = (data) => api.get("/civil-budget-control-materials", data);
export const addNewCivilBudgetControlMaterialApi = (data) => api.post("/civil-budget-control-materials", data);
export const updateCivilBudgetControlMaterialApi = (data) => api.patch("/civil-budget-control-materials", data);
export const approveCivilBudgetControlMaterialApi = (data) => api.put("/civil-budget-control-materials", data);
export const deleteCivilBudgetControlMaterialApi = (data) => api.delete("/civil-budget-control-materials", data);

export const getCivilBudgetMaterialApi = (data) => api.get("/civil-budget-materials", data);
export const addNewCivilBudgetMaterialApi = (data) => api.post("/civil-budget-materials", data);
export const updateCivilBudgetMaterialApi = (data) => api.patch("/civil-budget-materials", data);
export const approveCivilBudgetMaterialApi = (data) => api.put("/civil-budget-materials", data);
export const deleteCivilBudgetMaterialApi = (data) => api.delete("/civil-budget-materials", data);

export const getCivilBudgetScheduleApi = (data) => api.get("/civil-budget-schedules", data);
export const addNewCivilBudgetScheduleApi = (data) => api.post("/civil-budget-schedules", data);
export const updateCivilBudgetScheduleApi = (data) => api.patch("/civil-budget-schedules", data);
export const approveCivilBudgetScheduleApi = (data) => api.put("/civil-budget-schedules", data);
export const deleteCivilBudgetScheduleApi = (data) => api.delete("/civil-budget-schedules", data);

//applicant-documents
export const getApplicantDocumentApi = (data) => api.get("/applicant-documents", data);
export const addNewApplicantDocumentApi = (data) => api.post("/applicant-documents", data);
export const updateApplicantDocumentApi = (data) => api.patch("/applicant-documents", data);
export const approveApplicantDocumentApi = (data) => api.put("/applicant-documents", data);
export const deleteApplicantDocumentApi = (data) => api.delete("/applicant-documents", data);

//legality-documents
export const getLegalityDocumentApi = (data) => api.get("/legality-documents", data);
export const addNewLegalityDocumentApi = (data) => api.post("/legality-documents", data);
export const updateLegalityDocumentApi = (data) => api.patch("/legality-documents", data);
export const approveLegalityDocumentApi = (data) => api.put("/legality-documents", data);
export const deleteLegalityDocumentApi = (data) => api.delete("/legality-documents", data);

//handover-lists
export const getHandoverListApi = (data) => api.get("/handover-lists", data);
export const addNewHandoverListApi = (data) => api.post("/handover-lists", data);
export const updateHandoverListApi = (data) => api.patch("/handover-lists", data);
export const approveHandoverListApi = (data) => api.put("/handover-lists", data);
export const deleteHandoverListApi = (data) => api.delete("/handover-lists", data);

//followup-lists
export const getFollowupListApi = (data) => api.get("/followup-lists", data);
export const addNewFollowupListApi = (data) => api.post("/followup-lists", data);
export const updateFollowupListApi = (data) => api.patch("/followup-lists", data);
export const approveFollowupListApi = (data) => api.put("/followup-lists", data);
export const deleteFollowupListApi = (data) => api.delete("/followup-lists", data);

//handover-engeneering-lists
export const getHandoverListEngineeringApi = (data) => api.get("/handover-engeneering-lists", data);
export const addNewHandoverListEngineeringApi = (data) => api.post("/handover-engeneering-lists", data);
export const updateHandoverListEngineeringApi = (data) => api.patch("/handover-engeneering-lists", data);
export const approveHandoverListEngineeringApi = (data) => api.put("/handover-engeneering-lists", data);
export const deleteHandoverListEngineeringApi = (data) => api.delete("/handover-engeneering-lists", data);

export const getLegalityAssetApi = (data) => api.get("/legality-assets", data);
export const addNewLegalityAssetApi = (data) => api.post("/legality-assets", data);
export const updateLegalityAssetApi = (data) => api.patch("/legality-assets", data);
export const approveLegalityAssetApi = (data) => api.put("/legality-assets", data);
export const deleteLegalityAssetApi = (data) => api.delete("/legality-assets", data);

export const getBudgetApi = (data) => api.get("/budgets", data);
export const approveBudgetApi = (data) => api.put("/budgets", data);
export const addNewBudgetApi = (data) => api.post("/budgets", data);
export const updateBudgetApi = (data) => api.patch("/budgets", data);
export const deleteBudgetApi = (data) => api.delete("/budgets", data);

export const getNominatifApi = (data) => api.get("/nominatifs", data);
export const approveNominatifApi = (data) => api.put("/nominatifs", data);
export const addNewNominatifApi = (data) => api.post("/nominatifs", data);
export const updateNominatifApi = (data) => api.patch("/nominatifs", data);
export const deleteNominatifApi = (data) => api.delete("/nominatifs", data);

//perizinan
export const getLegalSiteplanApi = (data) => api.get("/legal-siteplans", data);
export const addNewLegalSiteplanApi = (data) => api.post("/legal-siteplans", data);
export const updateLegalSiteplanApi = (data) => api.patch("/legal-siteplans", data);
export const deleteLegalSiteplanApi = (data) => api.delete("/legal-siteplans", data);

export const getLegalPeilApi = (data) => api.get("/legal-peils", data);
export const addNewLegalPeilApi = (data) => api.post("/legal-peils", data);
export const updateLegalPeilApi = (data) => api.patch("/legal-peils", data);
export const deleteLegalPeilApi = (data) => api.delete("/legal-peils", data);

export const getLegalBridgeApi = (data) => api.get("/legal-bridges", data);
export const addNewLegalBridgeApi = (data) => api.post("/legal-bridges", data);
export const updateLegalBridgeApi = (data) => api.patch("/legal-bridges", data);
export const deleteLegalBridgeApi = (data) => api.delete("/legal-bridges", data);

export const getLegalRumijaApi = (data) => api.get("/legal-rumijas", data);
export const addNewLegalRumijaApi = (data) => api.post("/legal-rumijas", data);
export const updateLegalRumijaApi = (data) => api.patch("/legal-rumijas", data);
export const deleteLegalRumijaApi = (data) => api.delete("/legal-rumijas", data);

export const getLegalPermissionApi = (data) => api.get("/legal-permissions", data);
export const addNewLegalPermissionApi = (data) => api.post("/legal-permissions", data);
export const updateLegalPermissionApi = (data) => api.patch("/legal-permissions", data);
export const deleteLegalPermissionApi = (data) => api.delete("/legal-permissions", data);

export const getLegalFractionApi = (data) => api.get("/legal-fractionals", data);
export const addNewLegalFractionApi = (data) => api.post("/legal-fractionals", data);
export const updateLegalFractionApi = (data) => api.patch("/legal-fractionals", data);
export const deleteLegalFractionApi = (data) => api.delete("/legal-fractionals", data);

export const getAdminApi = (data) => api.get("/admins", data);
export const getOneAdminApi = (data) => api.getOne("/admins", data);
export const approveAdminApi = (data) => api.put("/admins", data);
export const addNewAdminApi = (data) => api.post("/admins", data);
export const updateAdminApi = (data) => api.patch("/admins", data);
export const deleteAdminApi = (data) => api.delete("/admins", data);